import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import TrackingScripts from './TrackingScripts';

export type Props = PropsWithChildren<{}>;

const TriggerTrackingContext = createContext<Dispatch<SetStateAction<boolean>>>(() => {});

export default function ThirdPartyTrackingProvider({ children }: Props) {
  const [trackingTriggered, setTrackingTriggered] = useState(false);

  return (
    <TriggerTrackingContext.Provider value={setTrackingTriggered}>
      <TrackingScripts />
      {children}
    </TriggerTrackingContext.Provider>
  );
}

export function useTrackingTrigger(): () => void {
  const setTrackingTriggered = useContext(TriggerTrackingContext);
  return () => setTrackingTriggered(true);
}
